import type { CSSObject } from '@emotion/react';

export const menu = (baseCSS: CSSObject): CSSObject => ({
  ...baseCSS,
  position: undefined,
  zIndex: undefined,
  margin: 0,
  boxShadow: undefined,
});
